import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils';

const Heart = ({ fill, ...props }) =>
	<svg width="25" height="24" viewBox="0 0 25 24" fill={fill} {...props}>
		<path d="M798.708333,814 C796.729167,814 794.854167,814.834783 793.5,816.191304 C792.145833,814.834783 790.270833,814 788.291667,814 C784.229167,814 781,817.234783 781,821.304348 C781,827.982609 792.354167,837.373913 792.875,837.791304 C793.083333,838 793.291667,838 793.5,838 C793.708333,838 793.916667,837.895652 794.125,837.791304 C794.645833,837.373913 806,827.982609 806,821.304348 C806,817.234783 802.770833,814 798.708333,814 Z" transform="translate(-781 -814)"/>
	</svg>;

Heart.propTypes = {
	fill: PropTypes.string,
};

Heart.defaultProps = {
	fill: getColor("dustyGray"),
};

export default Heart;
